import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router';
import {
  Form,
  FormItemLinkModule,
  Input,
  ModalFooter,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import {
  Item as ItemWrapper,
  ModalContent,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import { useI18n } from 'src/hooks/useRouterChange';
import { EFooterMenuType } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';
import { onFinishFailed } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Item = Form.Item;

const Edit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const name = 'footerMenuForm';
  const [form] = Form.useForm();
  const {
    data,
    navigationList,
    onCancel,
    onConfirm,
    occupiedSpecificField,
    isPrimary,
  } = props;
  const navigationGroups = get(data, 'navigationGroups');

  const _navi = (navigationList || []).map((i) => {
    const { title, uuid, isOccupied } = i;
    return {
      value: uuid,
      label: title,
      disabled: isOccupied && navigationGroups !== uuid,
    };
  });

  // console.log('_navi', _navi);

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, []);

  const handleOnError = (error) => {
    onFinishFailed(name, error);
    return false;
  };
  const handleOnFinish = (v) => {
    const _data = { ...(data || {}), ...v };
    onConfirm(_data);
    onCancel();
  };

  const params: any = useParams();

  const { contentUuid } = params;
  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });

  return (
    <React.Fragment>
      <Form
        name={name}
        form={form}
        onFinishFailed={handleOnError}
        onFinish={handleOnFinish}>
        <ModalContent>
          <Section className={css.section}>
            {isPrimary && (
              <ItemWrapper
                title={getI18n('salesChannelContent.index.menuItemType')}>
                <Item
                  noStyle
                  shouldUpdate={(p, c) => {
                    const pV = get(p, 'menuItemType');
                    const cV = get(c, 'menuItemType');
                    return cV !== pV;
                  }}>
                  {(f) => {
                    const { getFieldValue } = f;
                    const type = getFieldValue('menuItemType');

                    return (
                      <Item
                        name='menuItemType'
                        rules={[
                          {
                            required: true,
                            message: getI18n(
                              'salesChannelContent.index.pleaseselectatype',
                            ),
                          },
                        ]}>
                        <RadioGroup className={css.groupContainer}>
                          <RadioItem
                            value={EFooterMenuType.TextLink}
                            className={css.radio}>
                            {getI18n('salesChannelContent.index.textLink')}
                          </RadioItem>
                          <RadioItem
                            value={EFooterMenuType.NavigationGroup}
                            className={css.radio}>
                            {getI18n(
                              'salesChannelContent.index.navigationGroup',
                            )}
                          </RadioItem>
                          <RadioItem
                            disabled={
                              occupiedSpecificField[
                                EFooterMenuType.LocationSelector
                              ] && type !== EFooterMenuType.LocationSelector
                            }
                            value={EFooterMenuType.LocationSelector}
                            className={css.radio}>
                            {getI18n('general.hOCTitle.locationSelector')}
                          </RadioItem>
                          <RadioItem
                            disabled={
                              occupiedSpecificField[
                                EFooterMenuType.LanguageSelector
                              ] && type !== EFooterMenuType.LanguageSelector
                            }
                            value={EFooterMenuType.LanguageSelector}
                            className={css.radio}>
                            {getI18n('general.hOCTitle.languageSelector')}
                          </RadioItem>
                          <RadioItem
                            disabled={
                              occupiedSpecificField[
                                EFooterMenuType.CurrencySelector
                              ] && type !== EFooterMenuType.CurrencySelector
                            }
                            value={EFooterMenuType.CurrencySelector}
                            className={css.radio}>
                            {getI18n('general.hOCTitle.currencySelector')}
                          </RadioItem>
                          <RadioItem
                            disabled={
                              occupiedSpecificField[
                                EFooterMenuType.SocialMedia
                              ] && type !== EFooterMenuType.SocialMedia
                            }
                            value={EFooterMenuType.SocialMedia}>
                            {getI18n('general.hOCTitle.socialMedia')}
                          </RadioItem>
                        </RadioGroup>
                      </Item>
                    );
                  }}
                </Item>
              </ItemWrapper>
            )}

            <Item
              noStyle
              shouldUpdate={(p, c) => {
                const pV = get(p, 'menuItemType');
                const cV = get(c, 'menuItemType');
                return cV !== pV;
              }}>
              {(f) => {
                const { getFieldValue } = f;
                const type = getFieldValue('menuItemType');
                if (type === EFooterMenuType.TextLink) {
                  return (
                    <TextLink
                      linkSet={linkSet}
                      isPrimary={isPrimary}
                      salesChannelContentUuid={contentUuid}
                    />
                  );
                }
                if (type === EFooterMenuType.NavigationGroup) {
                  return <NaviSelector list={_navi} isPrimary={isPrimary} />;
                }
                if (
                  type === EFooterMenuType.LocationSelector ||
                  type === EFooterMenuType.LanguageSelector ||
                  type === EFooterMenuType.CurrencySelector ||
                  type === EFooterMenuType.SocialMedia
                ) {
                  return null;
                }
              }}
            </Item>
          </Section>
        </ModalContent>
      </Form>
      <ModalFooter
        onCancel={onCancel}
        onOk={() => {
          form.submit();
        }}
      />
    </React.Fragment>
  );
};

export default Edit;

const NaviSelector = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { list } = props;
  return (
    <ItemWrapper title={getI18n('salesChannelContent.index.navigationGroup')}>
      <Item
        name='navigationGroups'
        rules={[
          {
            required: true,
            message: getI18n(
              'salesChannelContent.index.pleaseselectanavigation',
            ),
          },
        ]}>
        <RadioGroup className={css.groupContainer}>
          {list.map((i, index) => {
            const { value, label, disabled } = i;
            const isLast = index === list.length - 1;
            return (
              <RadioItem
                key={value}
                value={value}
                className={isLast ? '' : css.radio}
                disabled={disabled}>
                {label}
              </RadioItem>
            );
          })}
        </RadioGroup>
      </Item>
      {/* <Item
        noStyle
        shouldUpdate={(p, c) => {
          const pV = get(p, 'navigationGroups');
          const cV = get(c, 'navigationGroups');
          return cV !== pV;
        }}>
        {(f) => {
          // const { getFieldValue } = f;
          //const uuid = getFieldValue('navigationGroups');
          return (
            <Item name='navigationGroups'>
              <RadioGroup className={css.groupContainer}>
                {list.map((i, index) => {
                  const { value, label, disabled } = i;
                  const isLast = index === list.length - 1;
                  return (
                    <RadioItem
                      key={value}
                      value={value}
                      className={isLast ? '' : css.radio}
                      disabled={disabled}>
                      {label}
                    </RadioItem>
                  );
                })}
              </RadioGroup>
            </Item>
          );
        }}
      </Item> */}
    </ItemWrapper>
  );
};

const TextLink = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPrimary, salesChannelContentUuid } = props;
  return (
    <React.Fragment>
      <ItemWrapper title={`${getI18n('general.text')}*`}>
        <Input
          maxLength={100}
          size='large'
          formProps={{
            name: 'title',
            rules: [
              {
                required: true,
                message: getI18n(
                  'general.advancedFilters.commonAmount.requiredMessage',
                ),
              },
            ],
          }}
        />
      </ItemWrapper>
      {isPrimary && (
        <ItemWrapper title={getI18n('general.link')}>
          <Item
            name={'link'}
            rules={[
              {
                validator: async (x, value) => {
                  const { linkType } = value || {};
                  if (!linkType) {
                    return Promise.reject(
                      new Error(
                        getI18n('salesChannelContent.index.pleasefillLink'),
                      ),
                    );
                  }
                },
              },
            ]}>
            <FormItemLinkModule
              // linkSet={linkSet}
              salesChannelContentUuid={salesChannelContentUuid}
            />
          </Item>
        </ItemWrapper>
      )}
    </React.Fragment>
  );
};
